import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import App from "./App";
import { AppConfigProvider } from "./context/AppConfig";
import { AppThemeProvider } from "./context/AppTheme";
import { AuthProvider } from "./context/Auth";
import { Toaster } from "react-hot-toast";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import * as manifest from "./manifest";
import ROUTE_PATHS from "./routes/routesPath";
import ReferFriendV3 from "./components/ReferFriendV3/ReferFriendV3";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <AppThemeProvider>
    <BrowserRouter>
      <AuthProvider>
          <Routes>
              <Route path = {ROUTE_PATHS.REFER_FRIEND} element={<ReferFriendV3 />} />
              <Route path = {ROUTE_PATHS.FRIEND_ENROL} element={<ReferFriendV3 />} />
              <Route path = {ROUTE_PATHS.DIRECT_REFER} element={<ReferFriendV3 />} />
              <Route
                  path="/*"
                  element={
                      <AppConfigProvider>
                          <React.StrictMode>
                              <App />
                          </React.StrictMode>
                      </AppConfigProvider>
                  }
              />
          </Routes>
      </AuthProvider>
    </BrowserRouter>
    <Toaster position="top-right" containerStyle={{ top: 80 }} />
  </AppThemeProvider>
);

manifest.initialize();
serviceWorkerRegistration.register({
  onUpdate: async (registration) => {
    // We want to run this code only if we detect a new service worker is
    // waiting to be activated.
    // Details about it: https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle
    if (registration?.waiting) {
      await registration.unregister();
      // Makes Workbox call skipWaiting()
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      // Once the service worker is unregistered, we can reload the page to let
      // the browser download a fresh copy of our app (invalidating the cache)
      console.log("New Version Of the App Detected!");
      window.location.reload();
    }
  },
});
